<template>
	<div>
		<div id="modal_overlay" v-if="showIssueDialog" @keyup.enter="showIssueDialog = false">
			<div class="issue-dialog" v-if="showIssueDialog">
				<h3 style="margin:0">{{issue.title}}</h3>
				<p style="text-align:center; margin-top:10px">{{issue.message}}</p>
        <p style="text-align:center; margin-top:10px">{{issue.smallDisclaimer}}</p>

				<button v-if="choiceRequired" class="button button--primary button--small" style="color:#fff; margin: 20px auto 0 auto; display: block" @click="RedirectToVagPage">
          View On Site Options
        </button>

				<button
					class="button button--primary button--small"
					style="color:#fff; margin: 20px auto 0 auto; display: block"
          @click="showIssueDialog = false"
				>Close</button>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data: () => ({
    showIssueDialog: false,
		issue: {
      type: null,
      title: null,
      message: null,
      smallDisclaimer: null,
    },
	}),
  computed: {
    choiceRequired() {
      return this.issue.type === "OnSiteOnly";
    }
  },
	methods: {
    RedirectToVagPage() {
			this.$parent.RedirectToVagPage();
		}
	}
};
</script>

<style scoped>
.issue-dialog {
	position: fixed;
	top: 20px;
	z-index: 999;
	width: auto !important;
	color: #333;
	background: #fff;
	padding: 20px;
	margin-top:40px;
	text-align: center;
}
#modal_overlay {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: rgba(0, 0, 0, 0.85);
	z-index: 99;
	display: flex;
    justify-content: center;
    align-items: center;
}
</style>